function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProductLine = function SvgProductLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Group_161",
    width: 24,
    height: 24,
    "data-name": "Group 161",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_19",
    d: "M0 0h24v24H0z",
    "data-name": "Path 19",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_20",
    d: "M17.2 11v5.6a.8.8 0 0 1-.8.8H3.6a.8.8 0 0 1-.8-.8V11H2V9.4l.8-4h14.4l.8 4V11zM4.4 11v4.8h11.2V11zm-.768-1.6h12.736l-.48-2.4H4.112zM5.2 11.8h6.4v2.4H5.2zM2.8 3h14.4v1.6H2.8z",
    "data-name": "Path 20",
    transform: "translate(2 2)",
    style: {
      fill: "#2980b9"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProductLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/productLine.0eb4a56e.svg";
export { ForwardRef as ReactComponent };